import { isDevMode } from '@angular/core';
import type { MecapEnvironment } from '../environment/type';
import { defaultMecapEnv } from '../mecap/default';

export const environment = {
  ...defaultMecapEnv,
  applicationName: 'TEST',
  isAngularDevMode: isDevMode(),
  apiUrl: 'https://meapp-test.plaveoodev.pctrade.hu/api',

  googleMapsApiKey: 'AIzaSyBIVk1MrShNeH3eumzyUyBCNAuBkq0v_hM',
  apiUrlPattern: /^https:\/\/meapp-test\.plaveoodev\.pctrade\.hu\/api(\/.*)?$/i,
  keycloakConfig: {
    realm: 'meapp-test',
    url: 'https://keycloak.milo.plaveoo.hu/',
    clientId: 'ui://e0cdecef-0544-44f2-ac76-9a6addd57ebb',
    initOptions: {
      onLoad: 'check-sso',
      redirectUri: window.location.origin,
      silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
    },
  },
} as const satisfies MecapEnvironment;
